<template>
  <div class="wechat-subscribe-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between items-center">
        <span>{{ $t('wechatSubscribe.title') }}</span>
        <div class="card-header-actions">
          <el-button size="small" @click="_queryWechatSubscribeMethod()">
            {{ $t('common.refresh') }}
          </el-button>
          <el-button 
            type="primary" 
            size="small" 
            @click="_openOpenSyncDataModel()">
            {{ $t('wechatSubscribe.syncUser') }}
          </el-button>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="wechatSubscribeInfo.users"
        border
        style="width: 100%">
        <el-table-column
          prop="name"
          label="姓名"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.phone || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="identityType"
          label="身份"
          align="center">
          <template slot-scope="scope">
            <el-tag
              effect="dark"
              :style="getIdentityStyle(scope.row.identityType)">
              {{ scope.row.identityType || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="用户备注"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tagidList"
          label="用户标签列表"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.tagidList && scope.row.tagidList !== '[]'">
              {{ scope.row.tagidList }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="openId"
          label="Open ID"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.openId || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="unionId"
          label="Union ID"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.unionId || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          align="center">
          <template slot-scope="scope">
            <span
              class="user-id-cell"
              @dblclick="editUserId(scope.row)"
              title="双击修改绑定关系">
              {{ scope.row.userId || '-' }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination-wrapper"
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-card>

    <sync-subscribe-wechat ref="syncSubscribeWechat" @success="handleSyncSuccess"></sync-subscribe-wechat>

    <el-dialog
      title="修改用户ID绑定关系"
      :visible.sync="editVisible"
      width="400px">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="Open ID">
          <el-input v-model="editForm.openId" disabled></el-input>
        </el-form-item>
        <el-form-item label="当前身份">
          <el-tag
            effect="dark"
            :style="getIdentityStyle(editForm.identityType)">
            {{ editForm.identityType || '未绑定' }}
          </el-tag>
        </el-form-item>
        <el-form-item label="绑定用户ID" prop="userId">
          <el-input v-model="editForm.userId" placeholder="请输入系统用户ID"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listWechatSubscribeDetail, updateWechatSubscribe } from '@/api/community/wechatSubscribeApi'
import { getCommunityId } from '@/api/community/communityApi'
import SyncSubscribeWechat from '@/components/community/syncSubscribeWechat'

export default {
  name: 'WechatSubscribeList',
  components: {
    SyncSubscribeWechat
  },
  data() {
    return {
      loading: false,
      wechatSubscribeInfo: {
        users: [],
        conditions: {
          nickname: '',
          appId: '',
          weChatType: '1000'
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      editVisible: false,
      editForm: {
        subId: '',
        openId: '',
        userId: '',
        identityType: ''
      }
    }
  },
  created() {
    this._listWechatSubscribes(this.page.current, this.page.size)
  },
  methods: {
    async _listWechatSubscribes(page, size) {
      try {
        this.loading = true
        const params = {
          page,
          row: size,
          ...this.wechatSubscribeInfo.conditions
        }
        const { data, total } = await listWechatSubscribeDetail(params)
        this.wechatSubscribeInfo.users = data
        this.page.total = total
      } catch (error) {
        this.$message.error(this.$t('wechatSubscribe.fetchError'))
      } finally {
        this.loading = false
      }
    },
    _openOpenSyncDataModel() {
      this.$refs.syncSubscribeWechat.open()
    },
    _queryWechatSubscribeMethod() {
      this.page.current = 1
      this._listWechatSubscribes(this.page.current, this.page.size)
    },
    handleSyncSuccess() {
      this._listWechatSubscribes(this.page.current, this.page.size)
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listWechatSubscribes(this.page.current, val)
    },
    handleCurrentChange(val) {
      this._listWechatSubscribes(val, this.page.size)
    },
    editUserId(row) {
      this.editForm = {
        subId: row.subId,
        openId: row.openId || '',
        userId: row.userId || '',
        identityType: row.identityType || ''
      }
      this.editVisible = true
    },
    async submitEdit() {
      try {
        await updateWechatSubscribe({
          subId: this.editForm.subId,
          userId: this.editForm.userId
        })
        this.$message.success('绑定关系修改成功')
        this.editVisible = false
        this._listWechatSubscribes(this.page.current, this.page.size)
      } catch (error) {
        this.$message.error('绑定关系修改失败')
      }
    },
    getIdentityStyle(identityType) {
      // 业主-绿色，员工-蓝色，双重身份-红色，未绑定-灰色
      const styles = {
        '业主': { backgroundColor: '#67c23a', borderColor: '#67c23a', color: '#fff' },
        '员工': { backgroundColor: '#409eff', borderColor: '#409eff', color: '#fff' },
        '业主,员工': { backgroundColor: '#f56c6c', borderColor: '#f56c6c', color: '#fff' },
        '未绑定': { backgroundColor: '#909399', borderColor: '#909399', color: '#fff' }
      }
      return styles[identityType] || styles['未绑定']
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-subscribe-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .card-header-actions {
    float: right;
  }

  .pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .user-id-cell {
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    &:hover {
      background-color: #ecf5ff;
    }
  }
}
</style>